<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title v-t="'c.mailingOverlay.stepSuccess.title'"/>
        <p v-t="'c.mailingOverlay.stepSuccess.text'" />
      </page>
    </div>

    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.mailingOverlay.stepSuccess.btnClose'"
              @click="close()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'

export default {
  mixins: [FormMixin, PageMixin],
  methods: {
    ...mapActions ({
      closeFullscreenModal: 'closeFullscreenModal',
      gotoStep: 'mailing/step/setIndex',
      reset: 'mailing/entry/reset'
    }),
    close () {
      this.closeFullscreenModal()
      this.gotoStep(0)
      this.reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mailings/steps/Success.vue